export const ITEM_PER_PAGE = 12
export const FETCH_DELAY_TIME = 3000
export const CATEGORY_DESCRIPTION_WORD_LIMIT = 200
export const MEDIA_POST_DEFAULT_ID = 'UPLOADING_ID'
export const WIKI_IMAGE_ASPECT_RATIO = 4 / 3
export const WIKI_METADATA_VALUE_LIMIT = 255
export const WIKI_SUMMARY_LIMIT = 255
export const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
export const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5
export const GPT3_COST_PER_1K_TOKENS = 0.02
export const GPT3_MAX_TRIES = 3
export const IMAGE_BOX_SIZE = 150
